export enum PortalType {
  PROJECT          = 'project',
  RATER_APPROVAL   = 'raterApproval',
  REPORT_RECIPIENT = 'reportRecipient',
  COLLABORATOR     = 'collaborator',
}
